import React, { Fragment } from "react";
import { Form, Button, Select, InputNumber } from "antd";
import { ReactSVG } from "react-svg";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSpinGames } from "../../actions/spinTheWheelGame";

const SpinRateForm = ({ handleSubmitForm, form, handleCancel, spinRateId }) => {
	const dispatch = useDispatch();
	const { spinGames, loading } = useSelector((state) => state.fetchSpinGames);
	useEffect(() => {
		dispatch(fetchSpinGames());
	}, []);
	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Game"
						name="game_id"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select
							placeholder="Required"
							showSearch
							optionFilterProp="children"
							loading={loading}
						>
							{spinGames &&
								spinGames.data.data.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Win Chance"
						name="win_chance"
						rules={[{ required: true, message: "Required" }]}
					>
						<InputNumber placeholder="Required" style={{ width: "100%" }} />
					</Form.Item>
					<Form.Item
						placeholder="Optional"
						label="Estimate Spin Chance"
						name="estimate_spin_chance"
					>
						<InputNumber style={{ width: "100%" }} />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{spinRateId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default SpinRateForm;
